<template>
  <div id="wrapper">
    <div class="normalheader ">
      <div class="hpanel">
        <div class="panel-body">
          <div id="hbreadcrumb" class="pull-right m-t-lg">
            <ol class="hbreadcrumb breadcrumb">
              <li>
                <router-link :to="{name: 'Dashboard'}">Dashboard</router-link>
              </li>
              <li class="active">
                <span>Overview</span>
              </li>
            </ol>
          </div>
          <h2 class="font-light m-b-xs">
            File Details
          </h2>
        </div>
      </div>
    </div>

    <div class="content">
      <Details v-if="file_id" :file_id="file_id"></Details>
    </div>
  </div>
</template>

<script>

import VueLadda from 'vue-ladda'
import Details from '../../components/file/Details'

export default {
  components: {Details, VueLadda},
  name: 'FileDetails',
  data () {
    return {
      file_id: null
    }
  },
  beforeMount () {
    this.file_id = parseInt(this.$route.params.file_id)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/document/FileDetails.vue